import React, { Component } from 'react';
import { NavBar, SearchBar, Toast } from 'antd-mobile';
import { ROOT_PATH } from '../../config';
import Table from '../../components/Table';
import send from '../../utils/send';

class RealTimeDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          id: 'col1',
          title: '名称',
          fixed: true, 
          width: 40,
          align: 'left', 
        },
        {
          id: 'col2',
          title: '耳号',
          width: 160,
          align: 'right'
        },
        {
          id: 'col3',
          title: '状态日期',
          width: 120,
          align: 'right'
        },
        {
          id: 'col4',
          title: '上次状态日期',
          width: 120,
          align: 'right'
        },
        {
          id: 'col5',
          title: '胎次',
          width: 50,
          align: 'right'
        },
        {
          id: 'col6',
          title: '相差天数',
          width: 65,
          align: 'right'
        }
      ],
      dataSource: [],
      details: []
    }
  }

  getDetail = (obj) => {
    Toast.loading('加载中...', 0);
    send(`${ROOT_PATH}/api/forward/ifarm/index-pig`, {
      method: 'POST',
      data: {
        'startDate': obj.date,
        'endDate': obj.date,
        'dateToday':obj.date,
        'gdType': [
          obj.gdType 
        ],
        'gdCode': [
          obj.gdCode
        ],
        'command': 'getCommand2',
        'datasFlag': "2"
      }
    })
      .then(res => {
        Toast.hide();
        this.updateTable(res.data);
      })
      .catch(execption => {
        Toast.hide();
        return execption;
      })
  }

  updateTable(data) {
    let dataSource = [];
    data.map(obj => {
      let newObj = {};
      newObj['col1'] = data.indexOf(obj)+1;
      newObj['col2'] = (obj.SWINE_TRACK) !== undefined ? (obj.SWINE_TRACK) : '-';
      newObj['col3'] = (obj.ACTIVITY_DATE) !== undefined ? (obj.ACTIVITY_DATE) : '-';
      newObj['col4'] = (obj.LAST_ACTIVITY_DATE) !== undefined ? (obj.LAST_ACTIVITY_DATE) : '-';
      newObj['col5'] = (obj.PARITY) !== undefined ? (obj.PARITY) : '-';
      newObj['col6'] = (obj.DATE_DIFF) !== undefined ? (obj.DATE_DIFF) : '-';
      dataSource.push(newObj);
    });

    this.setState({ 
      details: dataSource,
      dataSource
    });
  }

  componentDidMount() {
    this.getDetail(this.props.data);
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    }
  }

  search = (v) => {
    const results = this.state.dataSource.filter((obj) => {
      let swineId = obj.col2;
      return swineId.indexOf(v || '') >= 0
    })
    this.setState({
      details: results
    })
  }

  render() {
    return (
      <div className="report-detail-bg">
        <div className="report-header">
          <NavBar mode="light">母猪实时状态</NavBar>
          <SearchBar
            onChange={this.search.bind(this)}
            placeholder="搜索"
          />
        </div>
        <div className="report-content">
          <Table columns={this.state.columns} data={this.state.details} />
        </div>
      </div>
    )
  }
}

export default RealTimeDetail;